import { createContext } from 'react';

/**
 * Context used to show/hide things for educational discounts.
 *
 * @returns {Object}
 */
const EduContext = createContext({ isEdu: false });

export default EduContext;
